<template>
  <v-layout column class="card-container">
    <v-flex class="card-subtitle"> {{ adminText('workflowsAll.reply_to_e_mail_a8e268a', 'Reply-to e-mail') }} </v-flex>
    <v-flex class="mb-16">
      <span>{{ workflowLabel(replyTo || 'contact@core-event.co') }}</span>
    </v-flex>
    <v-flex class="card-subtitle"> {{ adminText('workflowsAll.date_and_time_07c9c3a', 'Date and time') }} </v-flex>
    <v-flex class="mb-16">
      <span>{{ workflowLabel(formattedDate) }}</span>
    </v-flex>
    <v-flex v-if="identifiers.length" class="card-subtitle"> {{ adminText('workflowsAll.recepients_c593a82', 'Recepients') }} </v-flex>
    <v-flex v-if="identifiers.length" class="mb-16">
      <div v-for="recepient in visibleRecipients(identifiers, allSentVisible)" :key="recepient">
        <span>{{ workflowLabel(recepient) }}</span>
      </div>
    </v-flex>
    <div v-if="shortcodesCountGreaterThan(identifiers, 5, allSentVisible)">
      <v-flex
        v-if="!allSentVisible"
        class="large-text card-action mt-8 text-uppercase"
        @click="allSentVisible = true"
      >
        <span>{{ adminText('workflowsAll.see_more_c510d6c', 'See more') }}</span>
        <v-icon color="secondary">expand_more</v-icon>
      </v-flex>
      <v-flex
        v-else
        class="large-text card-action mt-8 text-uppercase"
        @click="allSentVisible = false"
      >
        <span>{{ adminText('workflowsAll.see_less_47c77bf', 'See less') }}</span>
        <v-icon color="secondary">expand_less</v-icon>
      </v-flex>
    </div>
    <v-flex v-if="notSentIdentifiers.length" class="card-subtitle"> {{ adminText('workflowsAll.didn_t_receive_d3769bc', 'Didn\'t Receive') }} </v-flex>
    <v-flex v-if="notSentIdentifiers.length" class="mb-16">
      <div
        v-for="recepient in visibleRecipients(notSentIdentifiers, allUnsentVisible)"
        :key="recepient"
      >
        <span>{{ workflowLabel(recepient) }}</span>
      </div>
    </v-flex>
    <div v-if="shortcodesCountGreaterThan(notSentIdentifiers, 5, allUnsentVisible)">
      <v-flex
        v-if="!allUnsentVisible"
        class="large-text card-action mt-8 text-uppercase"
        @click="allUnsentVisible = true"
      >
        <span>{{ adminText('workflowsAll.see_more_c510d6c', 'See more') }}</span>
        <v-icon color="secondary">expand_more</v-icon>
      </v-flex>
      <v-flex
        v-else
        class="large-text card-action mt-8 text-uppercase"
        @click="allUnsentVisible = false"
      >
        <span>{{ adminText('workflowsAll.see_less_47c77bf', 'See less') }}</span>
        <v-icon color="secondary">expand_less</v-icon>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { formatDate } from '../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'email-recepients',
  props: {
    replyTo: {
      type: String,
      default: null,
    },
    dateAndTime: {
      type: String,
      default: null,
    },
    identifiers: {
      type: Array,
      default: null,
    },
    attendees: {
      type: Array,
      default: null,
    },
    recipientType: {
      type: String,
      default: null,
    },
    eventId: {
      type: String,
      default: null,
    },
    notSentIdentifiers: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      allSentVisible: false,
      allUnsentVisible: false,
      recepients: [],
    }
  },
  computed: {
    formattedDate() {
      return this.workflowDate(this.dateAndTime, 'LL H:mm')
    },
  },
  methods: {
    shortcodesCountGreaterThan(identifiers, count, allVisible) {
      return this.visibleRecipients(identifiers, allVisible).length > count
    },
    visibleRecipients(identifiers, allVisible) {
      let visibleAttendees = []
      visibleAttendees = this.attendees.map(attendee => {
        if (Object.values(identifiers).includes(attendee.id.toString())) {
          return !attendee.fields['First name']
            ? attendee.fields['Ime'] + ' ' + attendee.fields['Prezime']
            : attendee.fields['First name'] + ' ' + attendee.fields['Last name']
        }
      })

      return allVisible ? visibleAttendees : visibleAttendees.slice(0, 5)
    },
  },
}
</script>

<style scoped>
.card-container {
  background-color: rgba(255, 76, 0, 0.1);
  padding: 24px 30px 24px 24px;
  border-radius: 8px 0 0 8px;
}
.card-subtitle {
  color: #979797;
  font-size: 12px !important;
  margin-bottom: 4px;
}
.large-text {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  color: #ff4c00;
  cursor: pointer;
}
.shortcode-container {
  background-color: rgba(2, 119, 189, 0.2);
  margin-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  height: 24px;
  display: table;
}
.shortcode-text {
  font-size: 14px;
  color: #0277bd;
  line-height: 24px;
}
</style>
